import { Dispatch } from 'redux';
import { ApiAttestation } from '../http';
import { attestationActions } from '../slices/attestation-slice';

const {
  setAttestationRequestStart,
  setAttestationRequestSuccess,
  setAttestationRequestFailure,
  setAttestationRequestDefault,

  setAttestationOneRequest,
  setAttestationOneSuccess,
  setAttestationOneFailure,
  setAttestationOneDefault,

  setAttestationCurrentRequest,
  setAttestationCurrentSuccess,
  setAttestationCurrentFailure,
  setAttestationCurrentDefault,

  setAttestationApplicantsRequest,
  setAttestationApplicantsSuccess,
  setAttestationApplicantsFailure,
  setAttestationApplicantsDefault,
} = attestationActions;

//One
export const getAttestation = (id: string | number) => async (dispatch: Dispatch<any>) => {
  dispatch(setAttestationOneRequest());
  try {
    const data = await ApiAttestation.fetchOne(id);
    dispatch(setAttestationOneSuccess(data));
  } catch ({ message }) {
    dispatch(setAttestationOneFailure({ message }));
  }
};
export const clearAttestation = () => async (dispatch: Dispatch<any>) => {
  dispatch(setAttestationOneDefault());
};

//Current
export const getCurrentAttestation = () => async (dispatch: Dispatch<any>) => {
  dispatch(setAttestationCurrentRequest());
  try {
    const data = await ApiAttestation.current();
    dispatch(setAttestationCurrentSuccess(data));
  } catch ({ message }) {
    dispatch(setAttestationCurrentFailure({ message }));
  }
};
export const clearCurrentAttestation = () => async (dispatch: Dispatch<any>) => {
  dispatch(setAttestationCurrentDefault());
};

//Start
export const startAttestation =
  (id: number, data: Record<string, any>) => async (dispatch: Dispatch<any>) => {
    dispatch(setAttestationRequestStart());
    return new Promise((resolve, reject) => {
      ApiAttestation.start(id, data)
        .then((res) => {
          dispatch(setAttestationRequestSuccess());
          resolve(res);
        })
        .catch((res) => {
          dispatch(setAttestationRequestFailure({ message: res?.message }));
          reject(res);
        });
    });
  };

//Complete
export const completeAttestation =
  (id: string | number, userAnswers: any[]) => async (dispatch: Dispatch<any>) => {
    dispatch(setAttestationRequestStart());
    return new Promise((resolve, reject) => {
      ApiAttestation.complete(id, { userAnswers })
        .then((res) => {
          dispatch(setAttestationRequestSuccess());
          resolve(res);
        })
        .catch((res) => {
          dispatch(setAttestationRequestFailure({ message: res?.message }));
          reject(res);
        });
    });
  };

//Complete
export const stopAttestation =
  (id: string | number, reason: string) => async (dispatch: Dispatch<any>) => {
    dispatch(setAttestationRequestStart());
    try {
      await ApiAttestation.stop(id, reason);
      dispatch(setAttestationRequestSuccess());
    } catch ({ message }) {
      dispatch(setAttestationRequestFailure({ message }));
    }
  };

export const absentAttestation =
  (id: string | number, reason: string) => async (dispatch: Dispatch<any>) => {
    dispatch(setAttestationRequestStart());
    try {
      await ApiAttestation.absent(id, reason);
      dispatch(setAttestationRequestSuccess());
    } catch ({ message }) {
      dispatch(setAttestationRequestFailure({ message }));
    }
  };

//Clear request
export const clearAttestationRequest = () => async (dispatch: Dispatch<any>) => {
  dispatch(setAttestationRequestDefault());
};

export const getApplicants = () => async (dispatch: Dispatch) => {
  dispatch(setAttestationApplicantsRequest());
  try {
    const data = await ApiAttestation.getApplicants();
    dispatch(setAttestationApplicantsSuccess(data));
  } catch (error) {
    dispatch(setAttestationApplicantsFailure(error));
  }
};
export const clearApplicantsRequest = () => async (dispatch: Dispatch<any>) => {
  dispatch(setAttestationApplicantsDefault());
};
